// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card_card__9FnqG {
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  border-radius: 18px;
  box-shadow: var(--shadow-card);
  padding: 20px 22px;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

/* Variante "spotlight" (Client Analysis): oscura en light, superficie normal en dark */
.Card_dark__GLEaV {
  background: var(--dylo-spotlight-bg);
  border-color: var(--dylo-spotlight-border);
  color: var(--dylo-spotlight-text);
}

.Card_header__oT2U7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.Card_title__VX3NH {
  font-size: 15px;
  font-weight: 600;
  color: var(--dylo-ink);
  margin: 0;
  position: relative;
  padding-bottom: 6px;
}
.Card_title__VX3NH::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 34px;
  height: 2px;
  background: var(--dylo-line);
  border-radius: 2px;
}

.Card_dark__GLEaV .Card_title__VX3NH {
  color: #fff;
}
.Card_dark__GLEaV .Card_title__VX3NH::after {
  background: rgba(255, 255, 255, 0.25);
}

.Card_subtitle__zgCkR {
  font-size: 13px;
  font-weight: 500;
  color: var(--dylo-muted);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Card/Card.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oFAAoF;AACtF;;AAEA,uFAAuF;AACvF;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".card {\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  border-radius: 18px;\n  box-shadow: var(--shadow-card);\n  padding: 20px 22px;\n  transition: box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;\n}\n\n/* Variante \"spotlight\" (Client Analysis): oscura en light, superficie normal en dark */\n.dark {\n  background: var(--dylo-spotlight-bg);\n  border-color: var(--dylo-spotlight-border);\n  color: var(--dylo-spotlight-text);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  margin: 0;\n  position: relative;\n  padding-bottom: 6px;\n}\n.title::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 34px;\n  height: 2px;\n  background: var(--dylo-line);\n  border-radius: 2px;\n}\n\n.dark .title {\n  color: #fff;\n}\n.dark .title::after {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.subtitle {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dylo-muted);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card_card__9FnqG`,
	"dark": `Card_dark__GLEaV`,
	"header": `Card_header__oT2U7`,
	"title": `Card_title__VX3NH`,
	"subtitle": `Card_subtitle__zgCkR`
};
export default ___CSS_LOADER_EXPORT___;
